export const evaluationCriteriaKeys = {
  all: ["evaluation-criteria"] as const,
  list: () => [...evaluationCriteriaKeys.all, "list"] as const,
};
